import React, { useState } from "react";
import { Grid, GridCellProps, GridColumn as Column } from "@progress/kendo-react-grid";
import Loading from "../Loading";
import OrderDetailAction  from "../../Dashboard/Tabs/Orders/OrderDetailAction"; 
import { columnHeader } from "./NestedTable";

interface Props {
  tableData: any;
  tableConfig: any[];
  loading: boolean;
  parentData:any
  featuresAllowed: string[];
}

export default (props: Props) => {
  if (props.loading) return <Loading />;

  const [parentData, setParentData]= useState(props.parentData);
  
  const [featuresAllowed, setFeaturesAllowed] = React.useState<string[]>(props.featuresAllowed);
   
  const orderDetailActions = (props: GridCellProps) => (
    <OrderDetailAction
      {...props}
      parentRow = {parentData}
      featuresAllowed={featuresAllowed}
    />
  );

  return (
    <Grid style={{ fontSize: "100%" }} data={props.tableData} resizable>
      {props.tableConfig.map((column: any, key: number) => {
        if (column.custom) {
          return (
            <Column
              key={key}
              field={column.rowValue}
              title={column.headTitle}
              cell={(detailProps: any) => column.custom(detailProps)}
              headerCell={(props: any) =>
                columnHeader(props, column.tooltipText)
              }
            />
          );
        }
        return (
          <Column
            key={key}
            field={column.rowValue}
            title={column.headTitle}
            headerCell={(props: any) => columnHeader(props, column.tooltipText)}
          />
        );
      })}
      <Column cell={orderDetailActions} width="auto" />
    </Grid>
  );
};
